// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/theme/default.styl
// module id = 780
// module chunks = 4